import React, { useState, useEffect } from "react";
import axios from "axios";
import { Carousel, Table, Input, DatePicker, Modal, Card, Row, Col, message, Image, Checkbox, Button } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ConsoleSqlOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
import EnvironmentModal from "./components/EnvironmentModal";
import Carousel_news_ticker from "./components/Carousel_news_ticker";
const { RangePicker } = DatePicker;
const { Meta } = Card;
const AdminEnviorment = () => {
    const [title, setTitle] = useState('新增');
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [datas, setDatas] = useState([])
    const [messageApi, contextHolder] = message.useMessage();
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const handleOnEdit = (key) => {
        setTitle('修改');
        setColor('f09a45');
        setEdit(true);
        datas.map((value, index) => {
            if (index == key) {
                setEditCard(value);
            }
        })
        setOpen(true)
    }
    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/surrounding', { params: { "blog_type_id": 2 } })
            .then((response) => {
                setDatas(response.data);
                get_picture(response.data);
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    useEffect(() => {
        get_data();
    }, [])
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    const handleEdit = (file_id) => {
        setOpen(false);
        axios
            .patch(`/cramSchool/api/blog/surrounding`, [{ ...editcard, file_id, "blog_type_id": 2 }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_data();
                }
            })
        // console.log(editcard);
    }
    const handleSubmit = (file_id) => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            axios
                .post(`/cramSchool/api/blog/surrounding`, [{ ...editcard, file_id, "blog_type_id": 2 }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        get_data();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        get_data();
                    }
                })
        }
        // console.log(editcard);
    }
    const handleDelete = (id) => {
        const deleterow = [{ "blog_id": id }];
        axios
            .delete('/cramSchool/api/blog/surrounding', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_data();
                }
            })

    }

    return (
        <>
            {contextHolder}
            <EnvironmentModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                handleDelete={handleDelete}
            />
            <Row gutter={[8, 16]} justify='center' >
                <Col span={24}>
                    <Row justify={'end'} style={{
                        textAlign: 'center', paddingTop: '20px', paddingBottom: '20px'
                    }}>
                        <Col className='example'>
                            <Button style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle('新增'); setColor('d65b77'); setEditCard({}); setEdit(false); setOpen(true) }} icon={<PlusOutlined />}>新增環境介紹</Button >
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row gutter={[40, 8]} justify='center'>
                        <ImgCard title={true} edit={true} span={8} data={datas} handleOnEdit={handleOnEdit} />
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default AdminEnviorment;

const ImgCard = (props) => {
    const navigate = useNavigate();
    return (
        <>
            {
                props.data && props.data.map((value, index) => {
                    return (
                        < Col sm={{ span: 18 }
                        } md={{ span: props.span }} justify='center' style={{ position: 'relative' }}>
                            <Card
                                hoverable
                                style={{
                                    // minHeight: '15rem',
                                    // maxHeight: '30rem',
                                    position: 'relative',
                                    padding: '0px'
                                }}

                                cover={(
                                    <>
                                        {props.edit ? <>
                                            <Row style={{ position: 'relative', justifyContent: 'end' }}>
                                                <Col className='example' style={{ position: 'absolute', left: '90%', top: '0%', zIndex: 99 }}>
                                                    <EditOutlined
                                                        className='example'
                                                        style={{
                                                            backgroundColor: '#F9D4E5',
                                                            fontSize: '1.2rem',
                                                            borderRadius: '50%',
                                                            padding: '8px'
                                                        }}
                                                        onClick={e => props.handleOnEdit(index)}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                            : null}
                                        <Carousel_news_ticker
                                            file_url={value['file_url']}
                                        />
                                    </>)
                                }
                            >
                                <Row justify={'end'}>
                                    <Col span={24} style={{ fontSize: '20px' }}>{value['title']}</Col>
                                    <Col span={24}>
                                        <span style={{ fontSize: '16px' }}>{value['content']}</span>
                                    </Col>
                                    <Col>
                                        <span style={{ fontSize: '12px', color: '#999997' }}>{value['annoucement_time']}</span>
                                    </Col>
                                </Row>
                            </Card >
                        </Col >
                    )
                })
            }
        </>
    )
}